import { Input } from './Input.js';

export class TextInput extends Input {

}

